import '../immutable-draft-js-compat';
import { ApolloProvider } from '@apollo/client/react';
import { AlertProvider } from '@monorepo/react/alerts';
import { customizedApolloClient } from '@monorepo/react/apollo-link';
import { initSentry, SentryErrorBoundary } from '@monorepo/react/sentry';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import '@excalidraw/excalidraw/index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';
import './assets/stylesheets/draftjs.css';
import './assets/stylesheets/mention.css';
import './assets/stylesheets/static-toolbar.css';
import generatedIntrospection from './introspection';
import { App } from './app/app';
import library from './utils/font-awesome';
import i18next from './utils/i18n';
import { environment } from './environments/environment';

// Initialize Sentry/GlitchTip before rendering
initSentry({
  dsn: environment.sentry?.dsn,
  environment: environment.sentry?.environment,
  release: process.env.NX_SENTRY_RELEASE,
  tracesSampleRate: 0.2,
});
// We need to assign the imports to something, otherwise
// they will be "optimized out" of the final build
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _ = [i18next, library];
const root = createRoot(document.getElementById('root')!);
root.render(
  <Suspense fallback={null}>
    <SentryErrorBoundary>
      <ApolloProvider
        client={customizedApolloClient({
          possibleTypes: generatedIntrospection.possibleTypes,
        })}
      >
        <AlertProvider>
          <App />
        </AlertProvider>
      </ApolloProvider>
    </SentryErrorBoundary>
  </Suspense>,
);
